import {soundSliceSdk_seek, soundSliceSdk_getCurrentTimeAsync, soundSliceSdk_play} from "../eventBus/soundslice/soundSliceSdk";
import {generateUUID} from "../misc";
import {subscribeToReceiveMessageFromSoundsliceIframeEvents} from "../eventBus/soundslice/receiveMessageFromSoundsliceIframeEventBus";

interface IPromiseResolveAndReject {
  resolve: (...data: any[]) => void;
  reject: (data?: any) => void;
}

interface IRequestIdPromiseResolveHash{
  [key: string]: IPromiseResolveAndReject;
}

class SoundSlice{
  requestIdPromiseResolveHash: IRequestIdPromiseResolveHash = {};
  constructor() {
    subscribeToReceiveMessageFromSoundsliceIframeEvents(m => {
      if(!m.state?.requestId || !this.requestIdPromiseResolveHash[m.state.requestId]){ return; }
      const {resolve} = this.requestIdPromiseResolveHash[m.state.requestId];
      delete this.requestIdPromiseResolveHash[m.state.requestId];
      const {state, type, ...rest} = m;
      const values: any[] = Object.values(rest);
      // eslint-disable-next-line prefer-spread
      resolve.apply(null, values);
    });
  }

  async getCurrentTime(){
    return new Promise<number>((resolve, reject) => {
      const requestId = generateUUID();
      this.requestIdPromiseResolveHash[requestId] = {resolve, reject};
      soundSliceSdk_getCurrentTimeAsync({requestId});
    });
  }

  async seek(offset: number){
    return this.createAndRegisterRequestPromise((requestId)=> soundSliceSdk_seek(offset, {requestId}));
  }

  async play(){
    return this.createAndRegisterRequestPromise((requestId) => soundSliceSdk_play({requestId}));
  }

  private createAndRegisterRequestPromise(func: (requestId: string)=> void){
    return new Promise<number>((resolve, reject) => {
      const requestId = generateUUID();
      this.requestIdPromiseResolveHash[requestId] = {resolve, reject};
      func(requestId);
    });
  }
}

const soundSlice = new SoundSlice();
export default soundSlice;
